import PropTypes from 'prop-types';

const infoShape = PropTypes.shape({
  text: PropTypes.string,
  link: PropTypes.string,
});

const packageInfoShape = PropTypes.shape({
  title: PropTypes.string,
  operationType: PropTypes.string,
  btnText: PropTypes.string,
  description: PropTypes.string,
});

const roamingParamShape = PropTypes.shape({
  title: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  isPackage: PropTypes.bool,
  operationType: PropTypes.string,
});

const accumulatorShape = PropTypes.shape({
  size: PropTypes.number,
  rest: PropTypes.number,
  color: PropTypes.string,
  charged: PropTypes.bool,
  caption: PropTypes.string,
});

const usingOfferInfoShape = PropTypes.shape({
  expirationDate: PropTypes.string,
  buyBtnText: PropTypes.string,
  buyBtnLink: PropTypes.string,
});

const extraInfoShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
});

const offerAccumulatorsShape = PropTypes.shape({
  size: PropTypes.string,
  unit: PropTypes.string,
  icon: PropTypes.string,
});

const activeOfferShape = PropTypes.shape({
  extraInfo: extraInfoShape,
  lableTitle: PropTypes.string,
  expirationDate: PropTypes.string,
  isOfferActive: PropTypes.bool,
  title: PropTypes.string,
  soc: PropTypes.string,
  period: PropTypes.number,
  amount: PropTypes.number,
  icon: PropTypes.string,
  description: PropTypes.string,
  amountIcon: PropTypes.string,
  amountUnit: PropTypes.string,
  btnLink: PropTypes.string,
  accumulators: PropTypes.arrayOf(offerAccumulatorsShape),
});

const dataShape = PropTypes.shape({
  title: PropTypes.string,
  titleImageUrl: PropTypes.string,
  info: infoShape,
  roamingTitle: PropTypes.string,
  roamingTitleImageUrl: PropTypes.string,
  isRoaming: PropTypes.bool,
  packageInfo: PropTypes.arrayOf(packageInfoShape),
  roamingParams: PropTypes.arrayOf(roamingParamShape),
  accumulator: PropTypes.shape({
    data: accumulatorShape,
    voice: accumulatorShape,
    sms: accumulatorShape,
  }),
  usingOfferInfo: usingOfferInfoShape,
  activeOffer: activeOfferShape,
});

export {
  infoShape,
  packageInfoShape,
  roamingParamShape,
  accumulatorShape,
  usingOfferInfoShape,
  extraInfoShape,
  offerAccumulatorsShape,
  activeOfferShape,
  dataShape,
};
